// src/pages/gears/InstaX4.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ Correct image for Insta360 X4
import x4 from "./gearimages/x4.jpg";
import x4front from "./gearimages/x4front.jpg";


export default function InstaX4() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>Insta360 X4</h1>

              <p>
                The Insta360 X4 is a major leap forward in 360° action cameras, delivering
                stunning 8K 360 video, improved low‑light performance, and next‑generation
                FlowState stabilization. With its invisible selfie stick effect and powerful
                reframing tools, the X4 lets you capture immersive, cinematic footage that
                stands out anywhere.
              </p>

              <p>
                Built for adventure, the X4 is rugged and waterproof up to 10m (33 ft) without
                a case. It features a larger touchscreen, upgraded audio, and new shooting
                modes that give creators more flexibility than ever. If you want the most
                advanced 360 camera available today, the X4 is the one to beat.
              </p>

              {/* ⭐ UPDATED X4 FEATURE LIST */}
              <div className="place-block">
                <ul>
                  <li>8K 360° video at 30fps (H.265 encoding)</li>
                  <li>5.7K 360° video at 60fps for smoother action</li>
                  <li>4K single‑lens mode up to 120fps</li>
                  <li>FlowState stabilization with 360° horizon lock</li>
                  <li>Waterproof up to 10m (33 ft) without a case</li>
                  <li>2.5” tempered‑glass touchscreen (larger than X3)</li>
                  <li>Upgraded 4‑mic audio with enhanced wind reduction</li>
                  <li>Improved low‑light performance with new sensor tuning</li>
                  <li>TimeShift, hyperlapse, and ultra slow‑motion modes</li>
                  <li>Invisible selfie stick effect for clean 360 shots</li>
                  <li>Up to 135 minutes of recording per charge (in 4K mode)</li>
                  <li>Full reframing and editing in the Insta360 app</li>
                </ul>
              </div>

              {/* AFFILIATE BUTTONS */}
              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/4mjGugG"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/OE7Ayk"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={x4} alt="Insta360 X4 camera" />
              <img src={x4front} alt="Insta360 X4 front view" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
